import { Record } from 'immutable'
import { ListingStatus, ListingType } from './enums'
import { IListingLeaseData, ListingLeaseData } from './ListingLeaseData'
import { IListingSaleData, ListingSaleData } from './ListingSaleData'

export interface IAssociatedListing {
  readonly activeDate?: number
  readonly expirationDate?: number
  readonly leaseData?: IListingLeaseData
  readonly listingId: string
  readonly saleData?: IListingSaleData
  readonly status: ListingStatus
  readonly title: string
  readonly type: ListingType
}

const AssociatedListingRecord = Record({
  activeDate: undefined,
  expirationDate: undefined,
  leaseData: undefined,
  listingId: '',
  saleData: undefined,
  status: '',
  title: '',
  type: '',
})

export class AssociatedListing extends AssociatedListingRecord
  implements IAssociatedListing {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new AssociatedListing()
    }

    const { leaseData, saleData, ...rest } = initialState

    return new AssociatedListing({
      leaseData: leaseData ? ListingLeaseData.fromJS(leaseData) : undefined,
      saleData: saleData ? ListingSaleData.fromJS(saleData) : undefined,
      ...rest,
    })
  }

  public readonly activeDate?: number
  public readonly expirationDate?: number
  public readonly leaseData?: ListingLeaseData
  public readonly listingId: string
  public readonly saleData?: ListingSaleData
  public readonly status: ListingStatus
  public readonly title: string
  public readonly type: ListingType

  constructor(props?: Partial<AssociatedListing>) {
    props ? super(props) : super()
  }
}
